import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterBasicComponent } from './footer-basic/footer-basic.component';
import { FooterMainComponent } from './footer-main/footer-main.component';

@NgModule({
  declarations: [FooterBasicComponent, FooterMainComponent],
  imports: [CommonModule, RouterModule],
  exports: [FooterBasicComponent, FooterMainComponent],
})
export class FooterModule {}
